@if (!selectNextLanguageOnClick()) {
  <div im-dropdown position="block-end" (click)="$event.stopPropagation()">
    <button im-button imDropdownTrigger [class.inverted]="!ghostButton()">
      @if (selectedLanguage()) {
        <app-locale-flag
          class="lang-picker__flag flex-shrink-0"
          [languageCode]="selectedLanguage().code"
        ></app-locale-flag>
        {{
          showFullLanguageNames()
            ? (selectedLanguage().nativeLabel | translate)
            : (selectedLanguage().code | uppercase)
        }}
      }
      <i class="icon icon--arrow-dropdown" iconEnd></i>
    </button>
    <div imDropdownMenu>
      <div imDropdownGroup>
        @for (lang of availableLanguages(); track lang.label) {
          <button imDropdownItem (click)="onLanguageChange(lang.code)">
            {{ lang.nativeLabel | translate }}
            @if (selectedLanguage().code === lang.code) {
              <i class="icon icon--check lang-picker__selected"></i>
            }
          </button>
        }
      </div>
    </div>
  </div>
} @else {
  @if (!customButton.children.length) {
    <button
      im-button
      [class.inverted]="!ghostButton()"
      (click)="onSelectNextLanguage(value())"
    >
      @if (selectedLanguage()) {
        <div class="d-flex align-items-center">
          <app-locale-flag
            class="lang-picker__flag flex-shrink-0"
            [languageCode]="selectedLanguage().code"
          ></app-locale-flag>
          {{
            showFullLanguageNames()
              ? (selectedLanguage().nativeLabel | translate)
              : (selectedLanguage().code | uppercase)
          }}
        </div>
      }
      <i class="icon icon--check" iconEnd></i>
    </button>
  }
  <div #customButton (click)="onSelectNextLanguage(value())">
    <ng-content select="[custom-button]"></ng-content>
  </div>
}
